import React from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { useConfig } from '../config-context';
export function CommentEnd() {
    return React.createElement(SecureHtml, { as: "so-comment", html: "<![endif]-->", skipCleaning: true });
}
export function DoubleCommentEnd() {
    const config = useConfig();
    if (!config.renderComments) {
        return null;
    }
    return (React.createElement(SecureHtml, { as: "so-comment", html: "<!--<![endif]-->", skipCleaning: true }));
}
//# sourceMappingURL=comment-end.js.map